import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '15+',
  label: 'Years Experience'
}, {
  value: '40+',
  label: 'Active Fighters'
}, {
  value: '3',
  label: 'World Champions'
}, {
  value: '100%',
  label: 'Authentic Thai Style'
}];
export function Credibility() {
  return <section className="py-24 bg-zinc-900 relative overflow-hidden" data-id="element-27">
      {/* Texture overlay */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.65%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'
    }} data-id="element-28"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-29">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-30">
          <div className="lg:w-1/2" data-id="element-31">
            <motion.img initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} src="https://images.unsplash.com/photo-1555597673-b21d5c935865?q=80&w=2940&auto=format&fit=crop" alt="Muay Thai clinch training" className="w-full aspect-square object-cover grayscale border-l-4 border-red-600" data-id="element-32" />
          </div>

          <div className="lg:w-1/2" data-id="element-33">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-display text-5xl md:text-6xl text-white uppercase mb-6" data-id="element-34">
              Forged in <br data-id="element-35" />
              <span className="text-red-600" data-id="element-36">Blood & Sweat</span>
            </motion.h2>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="space-y-6 text-zinc-400 text-lg" data-id="element-37">
              <p data-id="element-38">
                Iron Eight isn't a fitness center. We are a dedicated fight gym
                built on the traditional principles of Thai stadium fighting.
                Our mats are stained with the hard work of amateur and
                professional fighters who demand excellence.
              </p>
              <p data-id="element-39">
                Led by Kru Marcus "The Anvil" Thorne, who spent 6 years fighting
                out of Bangkok, our curriculum is designed to break bad habits
                and forge unbreakable technique. Whether you want to fight under
                the lights or just train alongside those who do, you'll get the
                same uncompromising instruction.
              </p>
            </motion.div>

            <div className="grid grid-cols-2 gap-8 mt-12" data-id="element-40">
              {stats.map((stat, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2 + index * 0.1
            }} data-id="element-41">
                  <div className="font-display text-4xl text-white mb-1" data-id="element-42">
                    {stat.value}
                  </div>
                  <div className="text-sm text-zinc-500 uppercase tracking-wider font-semibold" data-id="element-43">
                    {stat.label}
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}